export const HOLIDAYS_2025 = [
    '01/01/2025',
    '04/03/2025',
    '18/04/2025',
    '21/04/2025',
    '01/05/2025',
    '19/06/2025',
    '07/09/2025',
    '12/10/2025',
    '02/11/2025',
    '15/11/2025',
    '20/11/2025',
    '25/12/2025',
]